export default __webpack_public_path__ + "static/media/Universe - Utopian and Guardian.f5bcabd2.png";